export enum Portals {
    Corporate = 3,
    Shop = 1,
    Join = 2,
    Account = 5,
    Reports = 6,
    All = 100
}